import React from 'react';
import './modal.css';
import { useSelector, useDispatch } from 'react-redux';
import { types } from '../../types/types';

export const DownloadProgressModal = () => {
    const dispatch = useDispatch();
    const { showModal, progress, downloading, total, canceled } = useSelector(state => state.download);

    if (!showModal) return null;

    const handleClose = () => {
        dispatch({type: types.downloadCloseModal});
    };

    return (
        <div className="modal-backdrop">
            <div className="modal-content">
                <h3>Descargando {total} albaranes</h3>
                <progress className='progress-bar' value={progress} max="100"></progress>
                <p>{progress}%</p>

                {!downloading && progress === 100 && (
                    <button className= 'btnSubmit' onClick={handleClose}>Cerrar</button>
                )}
                {downloading && !canceled && progress < 100 && (
                    <button className='btnSubmit' onClick={() => dispatch({ type: types.downloadCancel })}>
                        Cancelar
                    </button>
                )}
            </div>
        </div>
    );
};